package com.havn.app.features.settings.domain

data class McpApiKey(
    val id: String,
    val ownerAgentId: String,
    val agencyId: String?,
    val name: String,
    val keyPrefix: String,
    val scopes: List<String>,
    val createdAt: String,
    val lastUsedAt: String?,
    val revokedAt: String?,
    val apiKey: String? = null
) {
    val isActive: Boolean get() = revokedAt == null
}

interface McpApiKeyRepository {
    suspend fun listKeys(agencyId: String?): Result<List<McpApiKey>>
    suspend fun createOrRotateKey(agencyId: String?, name: String): Result<McpApiKey>
    suspend fun revokeKey(keyId: String): Result<Unit>
}
